import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function DatabaseUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-4053">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4054">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-4055">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-4056">
            The local business database for{' '}
            <span className="text-blue-600" data-id="element-4057">every team</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-4058">
            From sales to marketing, see how teams use our local business owner
            finder to grow their revenue.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4059">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4060">
            <div data-id="element-4061">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4062">
                B2B sales outreach
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4063">
                Sales teams use our built-in email sequencing to reach local
                small businesses directly, bypassing gatekeepers with verified
                business owner emails.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4064">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4065" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4066">
                Having the database and sequencing in one tool doubled our SDRs'
                daily output.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4067">
                — Mark R., VP of Sales
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4068">
            <div data-id="element-4069">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4070">
                Local marketing
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4071">
                Agencies build hyper-targeted local business listings to run
                personalized campaigns for their clients across specific regions
                and industries.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4072">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4073" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4074">
                The local business database coverage is unmatched. We find
                niches ZoomInfo completely misses.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4075">
                — Elena S., Agency Owner
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-4076">
            <div data-id="element-4077">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-4078">
                Franchise expansion
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-4079">
                Franchisors use the local business owner finder to identify
                successful independent operators and pitch them on conversion
                opportunities.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-4080">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-4081" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-4082">
                We can view business owner emails before exporting, ensuring we
                only contact the actual decision makers.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-4083">
                — David L., Head of Growth
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}